import customError from './customError.js';

export default customError('KeyError');
